export default "__VITE_ASSET__CiI2iXjJ__"